import brickBG from '../../../images/brick-texture.jpg';
import greenBrass from '../../../images/brass-texture-green.png';

export default theme => ({
    featuredText: {
        position: 'relative',
        padding: '60px 24px 120px',
        backgroundColor: theme.palette.secondary.main,
        margin: '0 -17.4px 0',
        width: 'calc(100% + 34.8px)',
        [theme.breakpoints.up('md')]: {
            padding: '60px',
            width: '100%',
            margin: '0 0 32px',
        },
        '& > p': {
            color: theme.palette.secondary.contrastText,
            fontSize: 24,
            fontWeight: '600',
            fontFamily: theme.headerFont,
            lineHeight: 1.25,
            letterSpacing: '0.056em',
            textTransform: 'uppercase',
            margin: 0,
            [theme.breakpoints.up('md')]: {
                fontSize: 32,
            },
        },
        '&.brick-bg-true': {
            backgroundImage: 'url(' + brickBG + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        },
        '&.green': {
            backgroundImage: 'url(' + greenBrass + ') !important',
            '& p': {
                color: theme.palette.common.black + ' !important',
            }
        },
    },
    featuredTextTheme: {
        ...theme.featuredTextTheme
    },
})